import { render } from "./ContextMenu.vue?vue&type=template&id=2725d37b&scoped=true"
const script = {}

import "./ContextMenu.vue?vue&type=style&index=0&id=2725d37b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2725d37b"]])

export default __exports__